import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

import * as CryptoJS from 'crypto-js';

interface IDateParts {
    day: string,
    month: string,
    year: string,
    hour: string,
    minute: string,
    second: string
}

@Injectable({
    providedIn: 'root'
})
export class EncriptionService {
    key = '';
    pass = '';
    clientSecret = '';
    date = '';
    aesKeyString = 'unaclavede16byte';
    aesIVString = 'unvectorde16byte';

    constructor() {
        this.key = environment.key;
        this.pass = environment.pass;
        this.clientSecret = environment.clientSecret;
        this.date = this.getDianDate();
        this.aesKeyString = environment.captchaPublic;
        this.aesKeyString = environment.captchaPublic;
    }

    async getClientSecret(): Promise<string> {
        const cs = "[" + this.clientSecret + "]" + "-" + "[" + this.date + "]";
        const encriptedCs = await this.cipher(this.key, cs);
        return encriptedCs;
    }

    async getPassword():  Promise<string> {
        const p = "[" + this.pass + "]" + "-" + "[" + this.date + "]";
        const encriptedP = await this.cipher(this.key, p);
        return encriptedP;
    }

    async cipher(encryptionKey: string, cleartext: string) {
        // Convert the key and plaintext to ArrayBuffer
        const encoder = new TextEncoder();
        const keyBuffer = encoder.encode(encryptionKey);
        const dataBuffer = encoder.encode(cleartext);

        // Generate an initialization vector (IV)
        const iv = new Uint8Array(16); // 16 bytes IV
        const ivBuffer = iv.buffer;

        // Import the key
        const cryptoKey = await crypto.subtle.importKey(
            'raw',
            keyBuffer,
            { name: 'AES-CBC' },
            false,
            ['encrypt']
        );

        // Encrypt the data
        const encryptedBuffer = await crypto.subtle.encrypt(
            { name: 'AES-CBC', iv: ivBuffer },
            cryptoKey,
            dataBuffer
        );

        // Convert the encrypted data to base64
        const encryptedArray = new Uint8Array(encryptedBuffer);
        const encryptedBase64 = btoa(String.fromCharCode(...encryptedArray));

        return encryptedBase64;
    }

    getDianDate():string {
        const date = new Date();

        const formatter = new Intl.DateTimeFormat('es-CO', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hourCycle: 'h24',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZone: 'America/Bogota',
        });

        const dateParts = formatter.formatToParts(date);

        const d:IDateParts = {day: '', month: '', year: '', hour: '', minute: '', second: ''};
        const dKeys:any = Object.keys(d);

        dateParts.map(part => {
            const currentKey = dKeys.filter((key:any) => key === part.type)[0] as keyof IDateParts;
            if (d[currentKey] !== undefined) {
                d[currentKey] = part.value;
            }
        });

        return `${d.year}-${d.month}-${d.day}T${d.hour}:${d.minute}:${d.second}`;
    }

    twoDigits(number:number):string{
       return number > 9 ? String(number) : '0'+number;
    }
    encriptarAesBase64(datoEncriptado: string) {

        return btoa(this.encriptarAes(datoEncriptado));
    }


    encriptarAes(datoClaro: string) {

        const aesKey = CryptoJS.enc.Hex.stringify(CryptoJS.enc.Utf8.parse(this.aesKeyString));
        const aesIV = CryptoJS.enc.Hex.stringify(CryptoJS.enc.Utf8.parse(this.aesIVString));
        const encriptado = CryptoJS.AES.encrypt(datoClaro, CryptoJS.enc.Hex.parse(aesKey), {
            iv: CryptoJS.enc.Hex.parse(aesIV),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return encriptado.toString();
    }

    convertirBase64(dato: string) {
        return btoa(dato);
    }

    decriptarAesBase64(datoEncriptado: string) {

        return this.decriptarAes(atob(datoEncriptado));
    }

    decriptarAes(datoEncriptado: string) {

        const aesKey = CryptoJS.enc.Hex.stringify(CryptoJS.enc.Utf8.parse(this.aesKeyString));
        const aesIV = CryptoJS.enc.Hex.stringify(CryptoJS.enc.Utf8.parse(this.aesIVString));
        const decrypted = CryptoJS.AES.decrypt(datoEncriptado, CryptoJS.enc.Hex.parse(aesKey), {
            iv: CryptoJS.enc.Hex.parse(aesIV),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        return decrypted.toString(CryptoJS.enc.Utf8);
    }
}
